
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"33","height":"28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.876 18.965l2.962-1.686 3.466 6.586-2.962 1.685-3.466-6.585z","fill":"#999"}}),_c('path',{attrs:{"d":"M24.983 9.638c.131.034.27.013.386-.058l4.517-2.57a.493.493 0 00.284-.296.521.521 0 00-.03-.416.486.486 0 00-.321-.25.468.468 0 00-.392.088l-4.518 2.571a.513.513 0 00-.19.676c.056.115.15.205.264.255zM26.593 1.115a.447.447 0 00-.68.112L23.108 5.13a.491.491 0 00.108.707l.158.048a.482.482 0 00.532-.193L26.71 1.79a.492.492 0 00-.117-.674zM31.71 11.855l-4.677.34a.451.451 0 00-.326.175.489.489 0 00-.098.367c.012.213.15.396.347.458l.156.048 4.645-.351a.477.477 0 00.379-.144.518.518 0 00-.043-.764.475.475 0 00-.393-.097l.01-.032z","fill":"#218665"}}),_c('path',{attrs:{"d":"M18.886.843a.827.827 0 00-1.119-.34.897.897 0 00-.316 1.123l1.322 2.449L4.83 16.557 8.434 23.4l2.075-.675 2.483 4.719c.1.194.27.34.472.405a.97.97 0 00.608-.077l7.68-4.37a.83.83 0 00.39-.491.866.866 0 00-.063-.672l-1.392-2.645 5.372-1.676 1.271 2.478a.811.811 0 001.12.34.983.983 0 00.327-1.163L18.887.843zm1.365 21.494l-6.234 3.547-1.91-3.63 6.981-2.187 1.163 2.27z","fill":"#0FA"}})])
          )
        }
      }
    